import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './stores';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

// vue-instyle (delight layer)
import 'vue-instyle/styles';
import { vPress, vRipple } from 'vue-instyle';

// Theme colors — warm, restrained palette drawn from the NomNomNomads brand
// (the camel-and-spaghetti mark): terracotta primary, espresso secondary,
// cream surfaces, warm near-black text. Replaces the stock Material blue.
const lightTheme = {
	dark: false,
	colors: {
		primary: '#C0552F', // terracotta
		secondary: '#5E4632', // espresso brown
		accent: '#E0A33E', // warm gold
		error: '#C0392B', // warm brick red
		info: '#3F7E8C', // muted dusty teal (cool counterpoint)
		success: '#5C8A3A', // leaf green
		warning: '#E08A2E', // amber
		background: '#FBF6EF', // warm cream
		surface: '#FFFFFF',
		'on-background': '#2E2520', // warm near-black
		'on-surface': '#2E2520'
	}
};

const vuetify = createVuetify({
	components,
	directives,
	// Reviews are scored on a 7-point scale per category, so every rating widget
	// (inputs and read-only displays alike) uses 7 stars instead of Vuetify's default 5.
	defaults: {
		VRating: { length: 7 }
	},
	theme: {
		defaultTheme: 'lightTheme',
		themes: {
			lightTheme
		}
	}
});

// API Service
import apiService from './services/api';

// Native platform initialization
import { initializeNative } from './plugins/native';

// Self-hosted Trailcam analytics (pageviews + SPA route changes). URL is per-env
// (.env.production / .env.staging); skipped when unset so dev/local don't ping it.
// data-api is the full Trailcam origin so the beacon isn't sent to nomnom's own host.
const trailcamUrl = process.env.VUE_APP_TRAILCAM_URL;
if (trailcamUrl) {
	const tc = document.createElement('script');
	tc.async = true;
	tc.defer = true;
	tc.src = trailcamUrl + '/tc.js';
	tc.dataset.site = 'nomnom';
	tc.dataset.api = trailcamUrl + '/event';
	document.head.appendChild(tc);
}

// Create and mount the Vue application
const app = createApp(App);
app.config.globalProperties.$api = apiService;
app.use(pinia);
app.use(router);
app.use(vuetify);
app.directive('press', vPress);
app.directive('ripple-instyle', vRipple);
app.mount('#app');

// Initialize native features after app is mounted
initializeNative();
